import * as ngCore from '@angular/core'
import * as store from '@attain-apps/fe/web/main/lib/store'

import { getActionsConfig } from './actions'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'
import * as subfeatures from './subfeatures'

/**
 * Manages information about the current user
 */
@ngCore.Injectable({ providedIn: 'root' })
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  /** @see {@link subfeatures.auth.Feature} */
  public readonly auth: subfeatures.auth.Feature
  /** @see {@link subfeatures.contexts.Feature} */
  public readonly contexts: subfeatures.contexts.Feature
  /** @see {@link subfeatures.employee.Feature} */
  public readonly employee: subfeatures.employee.Feature
  /** @see {@link subfeatures.siblingUsers.Feature} */
  public readonly siblingUsers: subfeatures.siblingUsers.Feature
  /** @see {@link subfeatures.zoneApps.Feature} */
  public readonly zoneApps: subfeatures.zoneApps.Feature

  constructor() {
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'Me',
      selectors: () => new Selectors(this),
    })

    this.auth = new subfeatures.auth.Feature(this)
    this.zoneApps = new subfeatures.zoneApps.Feature(this)
    this.contexts = new subfeatures.contexts.Feature(this)
    this.employee = new subfeatures.employee.Feature(this)
    this.siblingUsers = new subfeatures.siblingUsers.Feature(this)

    this.registerEffects(effects.startGet(this.auth), effects.executeGet())
  }
}
